import React from 'react'
import { Layout } from '../../components'
import {Helmet} from "react-helmet";
const About:React.FC = () => {
    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Learn more about Mark It As Done</title>
                <link rel="canonical" href="http://mysite.com/example" />
            </Helmet>
            <div>
            <p>We are a creative collective and technical advisory that partners with digital marketing and advertising agencies, consumer brands, and corporations towards meaningful audience engagement and growth.

Headquartered in Los Angeles, we are a team of designers, developers, and project managers who are always solving problems and providing creative solutions to our clients.

We are specialized in UI/UX design, custom WordPress theme and plugin development, Shopify e-commerce development, and custom software application development. We maintain a presence across a wide range of industries and business categories. Today we have the pleasure to serve businesses across the entertainment, hospitality, and the food industry.</p> 
            <h1>We build relationships.</h1>
            <p>We’re invested in your company’s success. Every solution is created with your needs in mind to reach new audiences or the same audience in a different way.</p>
            <h1>We value communication.</h1>
            <p>The key to a successful partnership is collaboration. Open, transparent discussions will ensure that we exceed expectations, meet your deadline, and stay within budget.</p>
            </div>
        </Layout>
    )
}

export default About

